import Abstract from "../../../abstract-view/abstract.js";

export default class Delivery extends Abstract {
  constructor(wrapperElement) {
    super();

    this._wrapperElement = wrapperElement;
    this._containerElement = null;
  }

  getElement() {
    return this._wrapperElement.parentElement.querySelector(`.section_delivery-map`);
  }

  getContent() {
    return this.getElement().outerHTML.trim();
  }

  setContent(content) {
    this.getElement().outerHTML = content;
  }

  getContainerElement() {
    this._containerElement = this.getElement().querySelector(`.delivery-map-container`);
    return this._containerElement;
  }
}
